var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2607 21.1901C19.1652 21.1764 19.0424 21.1764 18.9333 21.1901C16.5326 21.1082 14.623 19.1441 14.623 16.7298C14.623 14.2609 16.6145 12.2559 19.097 12.2559C21.5658 12.2559 23.5709 14.2609 23.5709 16.7298C23.5573 19.1441 21.6613 21.1082 19.2607 21.1901Z",
    stroke: "#242529",
    strokeWidth: 3.14032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5878 31.9526C24.662 33.7161 22.1088 34.7872 19.2958 34.7872C16.4829 34.7872 13.9297 33.7161 12.0039 31.9526C12.1121 30.9356 12.7612 29.9403 13.9189 29.1613C16.8832 27.1923 21.7301 27.1923 24.6728 29.1613C25.8305 29.9403 26.4796 30.9356 26.5878 31.9526Z",
    stroke: "#242529",
    strokeWidth: 3.14032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0793 35.0003C27.8722 35.0003 35.0003 27.8722 35.0003 19.0793C35.0003 10.2863 27.8722 3.1582 19.0793 3.1582C10.2863 3.1582 3.1582 10.2863 3.1582 19.0793C3.1582 27.8722 10.2863 35.0003 19.0793 35.0003Z",
    stroke: "#242529",
    strokeWidth: 3.14032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/My_profile.f3e03e771fb21e9634c1f5cf88e98b97.svg";
export { ForwardRef as ReactComponent };